<template>
    <div class="mb-5">
        <h1 class="mt-1">REPORT</h1>

        <div class="row">
            <div class="col-12 col-lg-10 mt-3 my-lg-0 px-0 mx-auto">
                <div class="row g-0 justify-content-evenly justify-content-sm-center align-items-center">
                    <div class="col-auto">
                        <a :href="'/structure/student/report/UserSubprocessStatsAction?userId=' + userId" 
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': selected === 'subprocess',
                            }">GRAFICO ANDAMENTO</a>
                    </div>
                    <div class="col-auto">
                        <a 
                            :href="'/structure/student/report/ReportContentsAction?userId=' + userId" 
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': selected === 'contents',
                            }">ATTIVITÀ</a>
                    </div>
                    <div class="col-auto">
                        <a 
                            :href="'/structure/student/report/UserHistoryTachiAction?userId=' + userId" 
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': selected === 'tachistoscopio',
                            }">TACHISTOSCOPIO</a>
                    </div>
                    <div class="col-auto">
                        <a 
                            :href="'/structure/student/report/UserCreditAction?userId=' + userId"
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': selected === 'credits',
                            }" 
                            class="erk btn btn-outline-secondary">MINUTI UTILIZZATI</a>
                    </div>
                    <div class="col-auto">
                        <a 
                            @click="openReportExport()" 
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': selected === 'export',
                            }">ESPORTA REPORT</a>
                    </div>
                </div>
            </div>
        </div>

        <MbStudentReportExportModal ref="reportExportModal" :userId="userId" />
    </div>
</template>
<script>

import MbStudentReportExportModal from './MbStudentReportExportModal.vue'

export default{
    components: {
        MbStudentReportExportModal
    },
    props: {
        selected: String,
        userId: [Number, String]
    },
    methods: {
        changeTab(url){
            window.location.href = url
        },
        openReportExport(){
            this.$refs.reportExportModal.toggle()
        }
    }
}

</script>